import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/login-left.png';
import _imports_1 from '@/assets/weixin.svg';
const _withScopeId = n => (_pushScopeId("data-v-27d791b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex"
};
const _hoisted_2 = {
  class: "content flex-1"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hidden md:block left flex-none w-[330px]"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_5 = {
  class: "right p-5 box-border flex-1"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center items-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-6 mr-2",
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text-base font-bold"
}, "登录即可免费领取试用会员")], -1));
const _hoisted_7 = {
  class: "flex mx-auto h-72 w-72 m-8 border-4 box-border rounded-md"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "button-container"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-xs text-center text-black"
}, " 使用微信扫码-关注公众号登录 ", -1));
const _hoisted_11 = {
  class: "flex flex-col items-center"
};
const _hoisted_12 = {
  class: "mt-2"
};
const _hoisted_13 = {
  class: "mt-2"
};
const _hoisted_14 = {
  class: "balance mt-10"
};
const _hoisted_15 = {
  class: "item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "普通会员", -1));
const _hoisted_17 = {
  class: "value"
};
const _hoisted_18 = {
  class: "item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "Pro会员", -1));
const _hoisted_20 = {
  class: "value"
};
const _hoisted_21 = {
  class: "item"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "剩余AI币", -1));
const _hoisted_23 = {
  class: "value"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "3.5提问每次消耗"), /*#__PURE__*/_createElementVNode("div", {
  class: "value"
}, "1枚AI币")], -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "4.0提问每次消耗"), /*#__PURE__*/_createElementVNode("div", {
  class: "value"
}, "2枚AI币")], -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "AI绘画每次消耗"), /*#__PURE__*/_createElementVNode("div", {
  class: "value"
}, "2枚AI币")], -1));
const _hoisted_27 = {
  key: 0,
  class: "tips"
};
const _hoisted_28 = {
  key: 1,
  class: "tips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_chatSliderbar = _resolveComponent("chatSliderbar");
  const _component_header_bar = _resolveComponent("header-bar");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_avatar = _resolveComponent("el-avatar");
  const _component_el_link = _resolveComponent("el-link");
  const _component_aiDialog = _resolveComponent("aiDialog");
  const _component_vip_dialog = _resolveComponent("vip-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_chatSliderbar), _createElementVNode("div", _hoisted_2, [_createVNode(_component_header_bar), _createVNode(_component_router_view, {
    "keep-alive": ""
  })]), _createVNode(_component_el_dialog, {
    class: "login-dialog box-border w-[90%] md:h-[460px] md:w-[773px]",
    modelValue: $setup.showLogin,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.showLogin = $event),
    "close-on-click-modal": false,
    center: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
      class: "mx-auto",
      src: $setup.qrcodeImg,
      alt: ""
    }, null, 8, _hoisted_8)])), [[_directive_loading, !$setup.qrcodeImg]]), _createElementVNode("div", _hoisted_9, [$setup.isMobile && !$setup.isWechat ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.redirectToURL_call && $setup.redirectToURL_call(...args)),
      class: "mobile-button"
    }, "快捷微信登录")) : _createCommentVNode("", true)]), _hoisted_10])])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_aiDialog, {
    width: "350px",
    title: "个人信息",
    modelValue: $setup.showUserInfo,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.showUserInfo = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_avatar, {
      size: 73,
      src: $setup.userInfo.avatar || require('@/assets/no_avatar.png')
    }, null, 8, ["src"]), _createElementVNode("div", _hoisted_12, _toDisplayString($setup.userInfo.nickname), 1), _createElementVNode("div", _hoisted_13, "MID:" + _toDisplayString($setup.userInfo.user_id), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [$setup.userInfo.vip_expire_time ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createTextVNode(_toDisplayString($setup.userInfo.vip_expire_time) + " 到期 ", 1), _createVNode(_component_el_link, {
      type: "primary",
      onClick: $setup.openVipDialog
    }, {
      default: _withCtx(() => [_createTextVNode("续费")]),
      _: 1
    }, 8, ["onClick"])], 64)) : (_openBlock(), _createBlock(_component_el_link, {
      key: 1,
      type: "primary",
      onClick: $setup.openVipDialog
    }, {
      default: _withCtx(() => [_createTextVNode("立即开通")]),
      _: 1
    }, 8, ["onClick"]))])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [$setup.userInfo.gaoji_vip_expire_time ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createTextVNode(_toDisplayString($setup.userInfo.gaoji_vip_expire_time) + " 到期 ", 1), _createVNode(_component_el_link, {
      type: "primary",
      onClick: $setup.openVipDialog
    }, {
      default: _withCtx(() => [_createTextVNode("续费")]),
      _: 1
    }, 8, ["onClick"])], 64)) : (_openBlock(), _createBlock(_component_el_link, {
      key: 1,
      type: "primary",
      onClick: $setup.openVipDialog
    }, {
      default: _withCtx(() => [_createTextVNode("立即开通")]),
      _: 1
    }, 8, ["onClick"]))])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createTextVNode(_toDisplayString($setup.userInfo.balance) + " 枚 ", 1), _createVNode(_component_el_link, {
      type: "primary",
      onClick: $setup.openVipDialog
    }, {
      default: _withCtx(() => [_createTextVNode("充值")]),
      _: 1
    }, 8, ["onClick"])])]), _hoisted_24, _hoisted_25, _hoisted_26, $setup.userInfo.vip_expire_time || $setup.userInfo.gaoji_vip_expire_time ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 尊敬的VIP用户,您使用将不消耗AI币 ")) : (_openBlock(), _createElementBlock("div", _hoisted_28, "提示：开通vip无限制次数使用!"))])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_vip_dialog, {
    modelValue: $setup.showVip,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.showVip = $event)
  }, null, 8, ["modelValue"])]);
}